import React from 'react';
import TablaClasificadorPresupuestario from '../components/presupuesto/tablaClasificadorPresupuestario';

function ClassPresupuestaria() {
  return (
      <div className='col-12 d-flex justify-content-center row'>
        <TablaClasificadorPresupuestario />
      </div>
  );
}

export default ClassPresupuestaria;




// WEBPACK FOOTER //
// ./src/pages/clasesPresupuestaria.js